var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 1272,
    viewBox: "0 0 375 1272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 1.63924e-05L0.000185291 24.9969L0.000202772 1272.24L375 1272.24L375 24.9969L187.5 1.63924e-05Z",
    fill: "url(#paint0_linear_1794_8719)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1794_8719",
    x1: 357.5,
    y1: 0.000312078,
    x2: -27.7857,
    y2: 8.47139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D77B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655288"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter);
export default __webpack_public_path__ + "static/media/bg-footer.26a15a8053a72204c9c555c65dd2e53c.svg";
export { ForwardRef as ReactComponent };